import { IconButton } from '@mui/material';
import styled, { css } from 'styled-components';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const DownloadPDF = styled(IconButton)`
  width: 100%;
  color: ${({ theme }) => theme.pantoneBlack};
  padding: 10px 0;
`;

export const DownloadContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 20px;
  cursor: pointer;
`;

export const ContainerPreview = styled.div<{ previewImage: string }>`
  display: flex;
  flex-direction: ${props => props.previewImage};
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 1rem 0 0;
`;

export const ContainerScoll = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

export const ButtonBaseDeletePreview = styled(IconButton)`
  &&& {
    color: ${({ theme }) => theme.red};
    fill: ${({ theme }) => theme.red};

    .MuiSvgIcon-root {
      color: ${({ theme }) => theme.red};
      fill: ${({ theme }) => theme.red};
    }
  }
`;

export const ButtonDeletePreview = styled(ButtonBaseDeletePreview)`
  &&& {
    position: absolute;
    top: 0;
    right: 0;
    display: none;
  }
`;

export const ButtonDeleteFile = styled(ButtonBaseDeletePreview)`
  &&& {
    margin: 0 0 0 auto;
  }
`;

export const BoxImage = styled.div`
  position: relative;
  width: 100%;
  max-width: 100px;
  overflow: hidden;
`;

export const ItemPreview = styled.div`
  cursor: zoom-in;
  position: relative;
  width: 100%;
  overflow: hidden;

  &:hover {
    ${ButtonDeletePreview} {
      display: block;
    }
  }
`;
export const ItemFile = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 0.6rem;
  background-color: ${({ theme }) => theme.white};
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 1rem;
  width: 100%;
  max-width: 600px;

  > p {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    margin: 0;
    max-width: 265px;

    > span {
      max-width: 280px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
    }
  }

  @media (max-width: 560px) {
    > p {
      max-width: 70%;
    }
  }
  @media (max-width: 406px) {
    > p {
      max-width: 53%;
    }
  }
`;

export const ImagePreview = styled.img`
  width: 100%;
  max-width: 100px;
  height: 100px;
`;

export const AreaIcons = styled.div`
  margin-left: auto;
`;

export const PaginationLabel = styled.div`
  align: left;
`;

interface IAreaFilesProps {
  $hasDataGridImages: boolean;
}
export const AreaFiles = styled.div<IAreaFilesProps>`
  overflow: auto;

  ${props =>
    props.$hasDataGridImages
      ? css`
          max-height: 300px;
        `
      : css`
          flex: 1;
          height: 100%;
        `}
`;

export const NameFile = styled.div`
  width: 100%;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 76vh;
`;

export const useStyles = makeStyles<Theme>(theme => ({
  buttonDownloadPreview: {
    '&': {
      position: 'absolute',
      bottom: '8px',
      right: '8px',
      backgroundColor: 'white',
      borderRadius: '50%',
      width: '28px',
      height: '28px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
      color: theme.palette.primary.main
    }
  },
  buttonBaseDeletePreview: {
    '&': {
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main
    }
  }
}));

export const BoxModalImages = styled.div`
  max-height: 100%;
  flex: 1;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const LabelFileName = styled.span`
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
`;
